import React, { useState, useEffect } from 'react'
import {
  Table,
  IconButton,
  Icon,
  Panel,
  Button,
  Row,
  Col,
  Modal,
  Input,
  ControlLabel,
  SelectPicker,
  Uploader,
  ButtonGroup,
  ButtonToolbar,
  Message,
} from 'rsuite'
import { DD_MM_YYYY_SLASH } from '../../../constants/date'
import {
  isValidators,
  getMaxLengthData,
  requiredFiled,
  isImageOrPdf,
} from '../../../utils/ValidatorUtils'
import ErrorMessage from '../../../components/message/errorMessage/ErrorMessage'
import { startLoading, doneLoading } from '../../../utils/loading'
import {
  downloadDurableArticlesFile,
  downloadAssetRegisterFile,
} from '../../../redux/actions/accountingExpenses'
import { Controller, useForm } from 'react-hook-form'
import moment from 'moment'
import { sessionGetItemStr } from '../../../utils/sessionHelpers'
import notification from '../../../utils/notification'
import ShowLimitLength from '../../../components/utils/ShowLimitLength'
import { downloadFile, previewFile } from '../../../utils/fileUtil'
import { v4 as uuidv4 } from 'uuid'
import OverlayLoader from '../../../components/OverlayLoader/OverlayLoader'
import { budgetFormat } from '../../../utils/formatterUtil'
import TagCell from '../../../components/cell/TagCell'
import TooltipButton from '../../../components/buttons/TooltipButton'
import { cloneDeep } from 'lodash-es'
import EditButton from '../../../components/buttons/editButton/EditButton'
import SaveButton from '../../../components/buttons/saveButton/SaveButton'
import ViewButton from '../../../components/buttons/viewButton/ViewButton'
import { SAVE_FAILED_MSG, SAVE_SUCCESS_MSG, SEARCH_ERR_MSG } from '../../../constants/msgText'
import {
  downloadAssetStockCountFile,
  saveAssetCount,
  saveAssetCountReviewSubmit,
  saveAssetCountSendToReview,
  searchAssetCountDetail,
  uploadAttachAssetCountFile,
} from '../../../redux/actions/accountingAssetClosure'
import { useHistory } from 'react-router-dom'
import pathname from '../../../constants/pathname'
import CancelButton from '../../../components/buttons/cancelButton/CancelButton'
import ConfirmWidget from '../../confirm/ConfirmWidget'
import { isEmpty } from 'lodash-es'
import IncomeRecordFileTable from '../../incomeRecordWidget/IncomeRecordFileTable'
import DownloadButton from '../../../components/buttons/downloadButton/downloadButton'
import InputForm from '../../../components/forms/input/InputForm'

export default function AddAssetCountingTable({ schema, loading, isSupplyOfficer, disabled }) {
  const { register, handleSubmit, errors, control, getValues, setValue, clearErrors } = useForm()
  const { Column, HeaderCell, Cell } = Table
  const [assetRegisSchema, setAssetRegisSchema] = useState(null)
  const [isLoading, setIsLoading] = useState(false)
  const [isAddDetail, setAddDetail] = useState(false)
  const [isEditMode, setIsEditMode] = useState(false)
  const [assetOtherAttach, setAssetOtherAttach] = useState([])
  const [deleteAttachFiles, setDeleteAttachFiles] = useState([])

  const [assetCountRemark, setAssetCountRemark] = useState(
    assetRegisSchema?.inputFrom?.assetCountRemark.value || ''
  )
  const [assetCountStatus, setAssetCountStatus] = useState(
    assetRegisSchema?.inputFrom?.assetCountStatus.value || ''
  )
  const [assetId, setAssetId] = useState('')
  const [isShowConfirm, setIsShowConfirm] = useState(false)
  const [filesStatus, setFilesStatus] = useState(false)

  const [isShowConfirmSendBack, setIsShowConfirmSendBack] = useState(false)
  const [isShowConfirmSubmitReview, setIsShowConfirmSubmitReview] = useState(false)
  const [bodyRequest, setBodyRequest] = useState(false)

  const projectCode = sessionGetItemStr('projectCode')
  const fs = localStorage.getItem('fontSize')
  const assetCountId = sessionGetItemStr('initialId')

  const history = useHistory()

  const LEVEL_APPROVE_TYPE = {
    SENDBACK: 1, //ส่งกลับแก้ไข
    ACCEPT: 2, //รับทราบ
  }

  const handleClickDetailModal = async (rowData) => {
    setIsLoading(true)
    startLoading()
    try {
      const response = await searchAssetCountDetail(rowData.id)

      if (response) {
        setAssetId(rowData.id)
        setAssetRegisSchema(response.model)

        setAssetCountRemark(response.model?.inputFrom?.assetCountRemark?.value || '')
        setAssetCountStatus(response.model?.inputFrom?.assetCountStatus?.value || '')

        setAssetOtherAttach(response?.model?.assetInfo?.otherPathFiles || [])

        setAddDetail(true)
      }
    } catch (e) {
      console.log(e)
      notification.open('error', {
        title: SEARCH_ERR_MSG,
        duration: 5000,
      })
    }
    doneLoading()
    setIsLoading(false)
  }

  const handleAssetCount = async () => {
    setIsLoading(true)
    startLoading()
    try {
      const request = {
        id: assetId,
        assetCountStatus: assetCountStatus || 0,
        assetCountRemark: assetCountRemark || '',
      }

      const response = await saveAssetCount(request)

      if (response?.model?.successed) {
        notification.open('success', {
          title: SAVE_SUCCESS_MSG,
          duration: 5000,
        })

        setAddDetail(false)
      } else {
        notification.open('error', {
          title: SAVE_FAILED_MSG,
          duration: 5000,
        })
      }
    } catch (e) {
      console.log('error', e)

      notification.open('error', {
        title: e?.response?.data?.errors?.message || DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    doneLoading()
    setIsLoading(false)
  }

  const onPreview = async (fileObj) => {
    startLoading()
    try {
      var file = await downloadDurableArticlesFile(fileObj?.path || fileObj)
      var fileName = uuidv4()

      previewFile(file, fileName)
    } catch (e) {
      console.log(e)
      notification.open('error', {
        title: 'ดาวน์โหลด ไม่สำเร็จ ',
        duration: 5000,
      })
    }
    doneLoading()
  }

  const onDownload = async (fileObj) => {
    // console.log('onDownload', fileObj)
    startLoading()
    try {
      var file = await downloadDurableArticlesFile(fileObj?.path || fileObj)
      var fileName = uuidv4()

      downloadFile(file, fileName)
    } catch (e) {
      console.log(e)
      notification.open('error', {
        title: 'ดาวน์โหลด ไม่สำเร็จ ',
        duration: 5000,
      })
    }
    doneLoading()
  }

  const onPreviewAssetRegister = async () => {
    startLoading()
    try {
      var file = await downloadAssetRegisterFile(projectCode)
      var fileName = uuidv4()

      previewFile(file, fileName)
    } catch (e) {
      console.log(e)
      notification.open('error', {
        title: 'ดาวน์โหลด ไม่สำเร็จ ',
        duration: 5000,
      })
    }
    doneLoading()
  }

  const onDelete = (rowData) => {
    console.log('onDelete ', rowData)
    let datas = cloneDeep(assetOtherAttach)

    let newArr = []
    let deleteArr = deleteAttachFiles

    if (datas.length > 0) {
      datas.map((item) => {
        if (rowData.id != item.id) {
          newArr.push(item)
        } else {
          deleteArr.push(item)
        }
      })
      setAssetOtherAttach(newArr)
      setDeleteAttachFiles(deleteArr)
    } else {
      setAssetOtherAttach(datas)
    }
  }

  const detailInRows = (objInfo, rowType = 'INPUT') => {
    // console.log('obj => ', objInfo)
    if (!objInfo) {
      return false
    }

    if (rowType == 'DATE') {
      // console.log('gggg => ', moment(moment(objInfo.value).toDate()).format(DD_MM_YYYY_SLASH))
      return (
        <Row style={{ marginTop: 10 }}>
          <Col lg={6} md={6} sm={24} xs={24}>
            {`${objInfo.label} : `}
          </Col>
          <Col lg={18} md={18} sm={24} xs={24}>
            {objInfo.value ? moment(moment(objInfo.value).toDate()).format(DD_MM_YYYY_SLASH) : ''}
          </Col>
        </Row>
      )
    } else if (rowType == 'FILE') {
      return (
        <Row style={{ marginTop: 10 }}>
          <Col lg={6} md={6} sm={24} xs={24}>
            {`${objInfo.label} : `}
          </Col>
          <Col lg={18} md={18} sm={24} xs={24}>
            {objInfo.value && (
              <div>
                <ButtonGroup>
                  <TooltipButton
                    isStart={true}
                    icon="eye"
                    tooltip={`แสดง`}
                    onClick={(e) => {
                      onPreview(objInfo.value)
                    }}
                  />
                  <TooltipButton
                    isStart={false}
                    icon="download"
                    tooltip={`ดาวน์โหลด`}
                    onClick={(e) => {
                      onDownload(objInfo.value)
                    }}
                  />
                </ButtonGroup>
              </div>
            )}
          </Col>
        </Row>
      )
    } else if (rowType == 'FILES') {
      if (assetOtherAttach?.length <= 0) {
        return ''
      }

      return (
        <div>
          <IncomeRecordFileTable
            data={assetOtherAttach}
            onPreview={onPreview}
            onDownload={onDownload}
            onDelete={onDelete}
            deleteable={false}
          />
        </div>
      )
    } else if (rowType == 'INPUT') {
      return (
        <Row style={{ marginTop: 10 }}>
          <Col lg={6} md={6} sm={24} xs={24}>
            {`${objInfo.label} : `}
          </Col>
          <Col lg={18} md={18} sm={24} xs={24}>
            {objInfo.value || ''}
          </Col>
        </Row>
      )
    } else {
      return false
    }
  }

  const handleAssetCountSendToReview = async () => {
    setIsLoading(true)
    startLoading()
    try {
      const request = {}
      const response = await saveAssetCountSendToReview(request, assetCountId)

      if (response?.model?.successed) {
        notification.open('success', {
          title: SAVE_SUCCESS_MSG,
          duration: 5000,
        })
        handleOnCancel()
      } else {
        notification.open('error', {
          title: SAVE_FAILED_MSG,
          duration: 5000,
        })
      }
    } catch (e) {
      console.log('error', e)
      notification.open('error', {
        title: e?.response?.data?.errors?.message || DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    doneLoading()
    setIsLoading(false)
  }

  const handleOnCancel = () => {
    if (isSupplyOfficer) {
      history.push({
        pathname: `${pathname.durableArticles.AssetCountingSupplyOfficer}`,
      })
    } else {
      history.push({
        pathname: `${pathname.durableArticles.AssetCounting}`,
      })
    }
  }

  const handleSaveFileAssetCount = () => {
    console.log('handleSaveFileAssetCount')
    // files
    const file = getValues(schema.assetCountAttach.name)
    console.log('file => ', file)

    const formData = new FormData()
    formData.append('Id', '')
    file &&
      file?.forEach((element) => {
        formData.append('AttchFile', element.blobFile)
      })

    callSaveFileAssetCount(formData)
  }

  const callSaveFileAssetCount = async (request) => {
    setIsLoading(true)
    startLoading()
    try {
      const response = await uploadAttachAssetCountFile(request, assetCountId)
      // console.log('saveAssetCountSendToReview ', response)
      if (response?.model?.successed) {
        notification.open('success', {
          title: SAVE_SUCCESS_MSG,
          duration: 5000,
        })
        setFilesStatus(false)
        setValue(schema.assetCountAttach.name, null)
        location.reload()
      } else {
        notification.open('error', {
          title: SAVE_FAILED_MSG,
          duration: 5000,
        })
      }
    } catch (e) {
      console.log('error', e)

      notification.open('error', {
        title: e?.response?.data?.errors?.message || DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    doneLoading()
    setIsLoading(false)
  }

  const onPreviewAssetCountDocument = async () => {
    setIsLoading(true)
    startLoading()
    try {
      var file = await downloadAssetStockCountFile(assetCountId, projectCode)

      var fileName = uuidv4()

      downloadFile(file, fileName)
    } catch (e) {
      console.log(e)
      notification.open('error', {
        title: 'ดาวน์โหลด ไม่สำเร็จ ',
        duration: 5000,
      })
    }
    doneLoading()
    setIsLoading(false)
  }

  const handleSubmitReview = async (approve_type, comments) => {
    console.log('handleSubmitReview', approve_type)

    setIsLoading(true)
    startLoading()
    try {
      const request = {
        id: assetCountId,
        approveType: approve_type,
        comment: comments || '',
      }
      const response = await saveAssetCountReviewSubmit(request, assetCountId)
      console.log('sssssss ', response)
      if (response?.model?.successed) {
        notification.open('success', {
          title: SAVE_SUCCESS_MSG,
          duration: 5000,
        })
        handleOnCancel()
      } else {
        notification.open('error', {
          title: SAVE_FAILED_MSG,
          duration: 5000,
        })
      }
    } catch (e) {
      console.log('error', e)

      notification.open('error', {
        title: e?.response?.data?.errors?.message || DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    doneLoading()
    setIsLoading(false)
  }

  const handleSubmitSendBack = (data) => {
    handleSubmitReview(LEVEL_APPROVE_TYPE.SENDBACK, data?.approveComment)
  }

  return (
    <>
      {isLoading && <OverlayLoader />}

      {schema.comments?.map((item) => {
        //ความเห็น
        return (
          <Row style={{ marginTop: 20, marginBottom: 20 }}>
            <Col lg={6} md={6} sm={24} xs={24} style={{ textAlign: 'right' }}>
              <b>{`${item.label} : `}</b>
            </Col>
            <Col lg={18} md={18} sm={24} xs={24}>
              <Message type="info" description={item.value} />
            </Col>
          </Row>
        )
      })}

      <Panel collapsible defaultExpanded bordered style={{ marginTop: 20 }}>
        <div className="table-all-articles">
          <Table
            wordWrap
            autoHeight={schema?.values.length <= 12}
            height={schema?.values.length > 12 ? 800 : undefined}
            headerHeight={fs <= 16 ? 40 : 80}
            loading={loading}
            data={schema?.values || []}
            style={{ marginTop: '20px' }}
            affixHeader
          >
            <Column width={80} align="center">
              <HeaderCell>ลำดับ</HeaderCell>
              <Cell>
                {(_, index) => {
                  return index + 1
                }}
              </Cell>
            </Column>

            <Column width={180} align="center">
              <HeaderCell>รหัสครุภัณฑ์</HeaderCell>
              <Cell>
                {(rowData) => {
                  return <b>{rowData.assetCode}</b>
                }}
              </Cell>
            </Column>

            <Column width={210} minWidth={210} flexGrow={1}>
              <HeaderCell>ชื่อครุภัณฑ์</HeaderCell>
              <Cell dataKey="assetName" />
            </Column>

            <Column width={180}>
              <HeaderCell>ประเภทครุภัณฑ์</HeaderCell>
              <Cell dataKey="assetType" />
            </Column>

            <Column width={180} align="right">
              <HeaderCell>ราคา/หน่วย (ราคาสุทธิไม่รวม VAT)</HeaderCell>
              <Cell>
                {(rowData) => {
                  return budgetFormat(rowData.totalPrice || 0)
                }}
              </Cell>
            </Column>

            <Column width={180} align="center">
              <HeaderCell>สถานะครุภัณฑ์</HeaderCell>
              {/* <Cell dataKey="assetStatus" /> */}
              <Cell>
                {(rowData) => {
                  let _bgColor = ''
                  let _color = '#ffffff'
                  switch (rowData.assetStatusCode) {
                    case '0': //รอขึ้นทะเบียน
                    case '2': // เจ้าหน้าที่พัสดุออกเลขครุภัณฑ์
                    case '7': //นักวิชาการเสนอพิจารณาปิดครุภัณฑ์
                    case '9': // เจ้าหน้าที่พัสดุเสนอพิจารณาปิดครุภัณฑ์
                      _bgColor = '#5b9dfe' // น้ำเงิน
                      break

                    case '1': // ภาคีขอขึ้นทะเบียน
                    case '6': // ภาคีขอปิดครุภัณฑ์
                    case '12': // อนุมัติปิดครุภัณฑ์'
                    case '8': //ผอ.สำนักอนุมัติปิดครุภัณฑ์
                    case '3': // เจ้าหน้าที่พัสดุรับขึ้นทะเบียน
                      _bgColor = '#2da888' // เขียว
                      break

                    case '4': //เจ้าหน้าที่พัสดุส่งกลับแก้ไขขึ้นทะเบียน
                    case '10': // ส่งกลับแก้ไขปิดครุภัณฑ์
                    case '11': // ผอ. อำนวยการส่งกลับแก้ไขปิดครุภัณฑ์
                      _bgColor = '#EEB189' // ส้ม
                      break

                    case '5': // เจ้าหน้าที่พัสดุไม่รับขึ้นทะเบียน
                      _bgColor = '#fb8a81' //แดง
                      break

                    default:
                      _bgColor = '#f2f1f1'
                      _color = '#575757'
                      break
                  }

                  return (
                    <TagCell
                      dataKey="assetStatus"
                      rowData={rowData}
                      bgColor={_bgColor}
                      color={_color}
                    />
                  )
                  //return <p style={{ color: _color }}>{rowData.assetStatus}</p>
                }}
              </Cell>
            </Column>

            <Column width={185} align="center" fixed="right">
              <HeaderCell>จัดการรายการ</HeaderCell>
              <Cell>
                {(rowData, index) => {
                  // if (rowData.isEnableEdit && !isViewMode) {
                  if (isSupplyOfficer) {
                    return (
                      <>
                        <ViewButton
                          children="แสดง"
                          onClick={() => {
                            handleClickDetailModal(rowData)
                          }}
                        />
                      </>
                    )
                  } else {
                    return (
                      <>
                        {disabled ? (
                          <>
                            <ViewButton
                              children="แสดง"
                              onClick={() => {
                                handleClickDetailModal(rowData)
                              }}
                            />
                          </>
                        ) : (
                          <>
                            <IconButton
                              appearance="ghost"
                              className="rs-btn-ghost-edit"
                              icon={<Icon icon="edit" className="bt-gost-icon-radius-edit" />}
                              onClick={() => {
                                handleClickDetailModal(rowData)
                              }}
                              // disabled={!disabled}
                              size="sm"
                            >
                              แก้ไขรายละเอียด
                            </IconButton>
                          </>
                        )}
                      </>
                    )
                  }
                }}
              </Cell>
            </Column>
          </Table>
        </div>
      </Panel>
      <Row style={{ marginTop: 10 }}>
        <Col
          lg={isSupplyOfficer ? 4 : 12}
          md={isSupplyOfficer ? 4 : 12}
          sm={24}
          xs={24}
          style={{ textAlign: 'center' }}
        >
          {isSupplyOfficer ? (
            <>
              {schema?.buttonText?.printDocAssetCount && (
                <Button
                  loading={isLoading}
                  appearance="subtle"
                  style={{ marginRight: 10 }}
                  disabled={!schema?.assetCountAttach?.values[0].path}
                  onClick={() => {
                    // onPreviewAssetCountDocument()
                    onDownload(schema?.assetCountAttach?.values[0].path)
                  }}
                >
                  <Icon icon="print" size="lg" /> {schema?.buttonText?.printDocAssetCount}
                </Button>
              )}
            </>
          ) : (
            <>
              <Row>
                {/* {schema?.assetCountAttach?.values?.length} */}
                <Col
                  lg={schema?.assetCountAttach?.values[0].path ? 18 : 24}
                  md={schema?.assetCountAttach?.values[0].path ? 18 : 24}
                  sm={24}
                  xs={24}
                >
                  <Controller
                    name={schema.assetCountAttach.name}
                    control={control}
                    // defaultValue={undefined}
                    rules={isValidators(schema.assetCountAttach.validators)}
                    render={(props) => {
                      return (
                        <Uploader
                          accept={schema.assetCountAttach.fileType || '.jpg, .jpeg, .png, .pdf'}
                          draggable
                          autoUpload={false}
                          multiple={false}
                          // removable={false}
                          disabled={disabled}
                          fileList={props.value || []}
                          onChange={(fileList) => {
                            if (isEmpty(fileList)) {
                              props.onChange(undefined)
                              setFilesStatus(false)
                            } else {
                              // props.onChange(fileList)
                              let files = []
                              files.push(fileList[fileList.length - 1])
                              //props.onChange(files)

                              if (isImageOrPdf(files[0].blobFile.type)) {
                                props.onChange(files)
                                setFilesStatus(true)
                              } else {
                                setFilesStatus(false)
                                notification.open('error', {
                                  title: `ชนิดที่รองรับ ${
                                    schema.assetCountAttach.fileType || '.jpg, .jpeg, .png, .pdf'
                                  }`,
                                  duration: 5000,
                                })
                              }
                            }
                          }}
                        >
                          <div>
                            <Icon size="2x" icon="upload2" />
                            <small className="uploder__text"></small>
                            {`  อัปโหลดไฟล์ตรวจนับ `}
                          </div>
                        </Uploader>
                      )
                    }}
                  />
                </Col>
                {schema?.assetCountAttach?.values[0].path && (
                  <Col lg={6} md={6} sm={24} xs={24}>
                    <div style={{ marginTop: 6 }}>
                      <DownloadButton
                        // disabled={!schema?.assetCountAttach?.values[0].path}
                        children="โหลดไฟล์ตรวจนับ"
                        onClick={() => {
                          onDownload(schema?.assetCountAttach?.values[0].path)
                        }}
                      />
                    </div>
                  </Col>
                )}
              </Row>

              {filesStatus && (
                <div>
                  <hr />
                  <SaveButton
                    disabled={!filesStatus}
                    children="อัปโหลดไฟล์ตรวจนับ"
                    onClick={() => {
                      handleSaveFileAssetCount()
                    }}
                  />
                </div>
              )}
            </>
          )}
        </Col>
        <Col
          lg={isSupplyOfficer ? 20 : 12}
          md={isSupplyOfficer ? 20 : 12}
          sm={24}
          xs={24}
          style={{ textAlign: 'right' }}
        >
          <ButtonToolbar style={{ marginTop: 6 }}>
            {isSupplyOfficer ? (
              <>
                {schema?.buttonText?.accept && (
                  <SaveButton
                    disabled={isLoading}
                    onClick={() => {
                      // handleSubmitReview(LEVEL_APPROVE_TYPE.ACCEPT)
                      setIsShowConfirmSubmitReview(true)
                    }}
                    icon="check-circle"
                    children={schema?.buttonText?.accept}
                  />
                )}

                {schema?.buttonText?.sendBack && (
                  <EditButton
                    disabled={isLoading}
                    onClick={() => {
                      // handleSubmitReview(LEVEL_APPROVE_TYPE.SENDBACK)
                      setIsShowConfirmSendBack(true)
                    }}
                    icon="send"
                    children={schema?.buttonText?.sendBack}
                  />
                )}
              </>
            ) : (
              <>
                {schema?.buttonText?.printDocAssetCount && (
                  <Button
                    loading={isLoading}
                    appearance="subtle"
                    style={{ marginRight: 10 }}
                    onClick={() => {
                      onPreviewAssetCountDocument()
                    }}
                  >
                    <Icon icon="print" size="lg" /> {schema?.buttonText?.printDocAssetCount}
                  </Button>
                )}

                {schema?.buttonText?.sendTo && (
                  <SaveButton
                    icon="send"
                    children={schema?.buttonText?.sendTo}
                    // disabled={!disabled}
                    onClick={() => {
                      // handleAssetCountSendToReview()
                      setIsShowConfirm(true)
                    }}
                  />
                )}
              </>
            )}

            <CancelButton
              children="ยกเลิก"
              onClick={() => {
                handleOnCancel()
              }}
            />
          </ButtonToolbar>
        </Col>
      </Row>

      {/* Modal เพิ่มรายละเอียด */}
      <Modal
        size="lg"
        show={isAddDetail}
        onHide={(e) => {
          setAddDetail(false)
        }}
      >
        <Modal.Header>
          <Modal.Title>{isEditMode ? 'เพิ่ม/แก้ไขรายละเอียด' : 'ดูรายละเอียด'}</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ maxHeight: '1000px !important' }}>
          <Panel>
            {assetRegisSchema && (
              <>
                {assetRegisSchema?.assetInfo?.assetName &&
                  detailInRows(assetRegisSchema.assetInfo.assetName)}

                {assetRegisSchema?.assetInfo.price &&
                  detailInRows(assetRegisSchema.assetInfo.price)}

                {assetRegisSchema?.assetInfo?.assetSerialNo &&
                  detailInRows(assetRegisSchema.assetInfo.assetSerialNo)}

                {assetRegisSchema?.assetInfo?.assetModel &&
                  detailInRows(assetRegisSchema.assetInfo.assetModel)}

                {assetRegisSchema?.assetInfo?.assetBrand &&
                  detailInRows(assetRegisSchema.assetInfo.assetBrand)}

                {assetRegisSchema?.assetInfo?.assetType &&
                  detailInRows(assetRegisSchema.assetInfo.assetType)}

                {/* เลขที่ใบเสร็จ */}
                {assetRegisSchema?.assetInfo?.assetBillNo &&
                  detailInRows(assetRegisSchema.assetInfo.assetBillNo)}

                {/* วันที่ในใบเสร็จ */}
                {assetRegisSchema?.assetInfo?.assetBillDate &&
                  detailInRows(assetRegisSchema.assetInfo.assetBillDate, 'DATE')}

                {assetRegisSchema?.assetInfo?.status &&
                  detailInRows(assetRegisSchema.assetInfo.status)}

                {assetRegisSchema?.assetInfo?.billPathFile &&
                  detailInRows(assetRegisSchema.assetInfo.billPathFile, 'FILE')}

                {assetRegisSchema?.assetInfo?.picturePathFile &&
                  detailInRows(assetRegisSchema.assetInfo.picturePathFile, 'FILE')}

                {assetRegisSchema?.assetInfo?.otherPathFiles &&
                  detailInRows(assetRegisSchema.assetInfo.otherPathFiles, 'FILES')}
              </>
            )}

            <hr />
            <br />

            {assetRegisSchema?.inputFrom?.assetCountStatus && (
              <Row style={{ marginTop: 10 }}>
                <Col lg={6} md={6} sm={24} xs={24}>
                  {/* สถานะการตรวจสอบ
                   */}
                  <ControlLabel>
                    {requiredFiled(
                      assetRegisSchema?.inputFrom?.assetCountStatus.validators,
                      assetRegisSchema?.inputFrom?.assetCountStatus.label
                    )}
                  </ControlLabel>
                </Col>
                <Col lg={18} md={18} sm={24} xs={24}>
                  <ErrorMessage
                    error={errors[assetRegisSchema?.inputFrom?.assetCountStatus?.name]}
                  />
                  <Controller
                    name={assetRegisSchema?.inputFrom?.assetCountStatus?.name}
                    control={control}
                    // defaultValue={''}
                    defaultValue={assetCountStatus}
                    rules={isValidators(assetRegisSchema?.inputFrom?.assetCountStatus.validators)}
                    render={(props) => {
                      return (
                        <SelectPicker
                          data={assetRegisSchema?.inputFrom?.assetCountStatus?.options}
                          value={props.value}
                          block
                          placeholder="เลือก"
                          onChange={(value) => {
                            props.onChange(value)
                            setAssetCountStatus(value)
                          }}
                          disabled={assetRegisSchema?.inputFrom?.assetCountStatus.disabled}
                        />
                      )
                    }}
                  />
                </Col>
              </Row>
            )}

            {assetRegisSchema?.inputFrom?.assetCountRemark && (
              <Row style={{ marginTop: 10 }}>
                <Col lg={6} md={6} sm={24} xs={24}>
                  <ControlLabel>
                    {requiredFiled(
                      assetRegisSchema?.inputFrom?.assetCountRemark.validators,
                      assetRegisSchema?.inputFrom?.assetCountRemark.label
                    )}
                  </ControlLabel>
                </Col>
                <Col lg={18} md={18} sm={24} xs={24}>
                  <ErrorMessage
                    error={errors[assetRegisSchema?.inputFrom?.assetCountRemark.name]}
                  />
                  <Controller
                    name={assetRegisSchema?.inputFrom?.assetCountRemark.name}
                    control={control}
                    defaultValue={assetCountRemark || ''}
                    rules={isValidators(assetRegisSchema?.inputFrom?.assetCountRemark.validators)}
                    render={(props) => {
                      return (
                        <>
                          <Input
                            componentClass="textarea"
                            rows={4}
                            placeholder={
                              'ระบุ' + assetRegisSchema?.inputFrom?.assetCountRemark.label
                            }
                            value={props.value}
                            maxLength={
                              getMaxLengthData(
                                assetRegisSchema?.inputFrom?.assetCountRemark.validators
                              ).value
                            }
                            onChange={(value, e) => {
                              props.onChange(value)
                              setAssetCountRemark(value)
                            }}
                            disabled={assetRegisSchema?.inputFrom?.assetCountRemark.disabled}
                          />

                          <ShowLimitLength
                            textLength={props.value?.length || 0}
                            maxLength={
                              getMaxLengthData(
                                assetRegisSchema?.inputFrom?.assetCountRemark.validators
                              )?.value
                            }
                          />
                        </>
                      )
                    }}
                  />
                </Col>
              </Row>
            )}
          </Panel>
        </Modal.Body>
        <Modal.Footer>
          {assetRegisSchema?.button?.save && (
            <SaveButton
              children={assetRegisSchema?.button?.save}
              onClick={() => {
                handleAssetCount()
              }}
            />
          )}

          {assetRegisSchema?.button?.cancel && (
            <CancelButton
              children={assetRegisSchema?.button?.cancel}
              onClick={() => {
                setAddDetail(false)
              }}
            />
          )}
        </Modal.Footer>
      </Modal>

      {/* Modal ส่งกลับแก้ไข */}
      <Modal
        size="lg"
        show={isShowConfirmSendBack}
        onHide={(e) => {
          setIsShowConfirmSendBack(false)
        }}
      >
        <Modal.Header>
          <Modal.Title>{'ยืนยันการส่งกลับแก้ไข'}</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ maxHeight: '1000px !important' }}>
          <Panel>
            <InputForm
              schema={schema.approveComment}
              rows={3}
              componentClass="textarea"
              register={register}
              Controller={Controller}
              control={control}
              errors={errors}
              setValue={setValue}
              clearErrors={clearErrors}
            />
          </Panel>
        </Modal.Body>
        <Modal.Footer>
          <SaveButton
            children="ยืนยันการส่งกลับแก้ไข"
            icon="send"
            onClick={handleSubmit(handleSubmitSendBack)}
          />

          <CancelButton
            children="ยกเลิก"
            onClick={() => {
              setIsShowConfirmSendBack(false)
            }}
          />
        </Modal.Footer>
      </Modal>

      <ConfirmWidget
        title={'ยืนยันการแจ้งผลตรวจนับ'}
        show={isShowConfirm}
        onCancle={() => setIsShowConfirm(false)}
        onConfirm={handleAssetCountSendToReview}
      />

      {/* <ConfirmWidget
        title={'ยืนยันการส่งกลับแก้ไข'}
        show={isShowConfirmSendBack}
        onCancle={() => setIsShowConfirmSendBack(false)}
        onConfirm={() => handleSubmitReview(LEVEL_APPROVE_TYPE.SENDBACK)}
      /> */}

      <ConfirmWidget
        title={'ยืนยันรับทราบ'}
        show={isShowConfirmSubmitReview}
        onCancle={() => setIsShowConfirmSubmitReview(false)}
        onConfirm={() => handleSubmitReview(LEVEL_APPROVE_TYPE.ACCEPT)}
      />
    </>
  )
}
